<div class="prs-password-field" ishFocusOutside (isFocusedOutside)="onFocusOutside($event)">
  <div class="prs-password-field__label-row">
    <label class="prs-password-field__label col-form-label" [attr.for]="inputId">
      {{ labelKey | translate }}
    </label>
    @if (canClear) {
    <button
      type="button"
      class="btn btn-link prs-password-field__clear"
      data-testing-id="password-clear"
      (click)="clearPassword($event)"
    >
      {{ 'account.login.password.clear' | translate }}
    </button>
    }
  </div>

  <div class="prs-password-field__control">
    <input
      class="form-control"
      [id]="inputId"
      [attr.aria-describedby]="ariaDescribedBy"
      [attr.aria-invalid]="ariaInvalid ? 'true' : undefined"
      [attr.data-testing-id]="testingId || inputId"
      [formControl]="control"
      [autocomplete]="autocomplete"
      [type]="showPassword ? 'text' : 'password'"
      (input)="onInput()"
    />

    @if (showButton) {
    <button
      class="btn btn-link text-decoration-none prs-password-field__toggle"
      role="switch"
      type="button"
      [attr.aria-checked]="showPassword"
      [title]="(showPassword ? 'form.password.show.button.label.hide' : 'form.password.show.button.label') | translate"
      (click)="togglePasswordVisibility()"
    >
      <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'" aria-hidden="true"></i>
    </button>
    }
  </div>
</div>
